module.exports = __webpack_public_path__ + "media/images/icons/SVG/031-630257695c759c22452c2873fd2717e4.svg";